import { render, staticRenderFns } from "./DialogoUsuariosForm.vue?vue&type=template&id=2dfabc99&scoped=true&"
import script from "./DialogoUsuariosForm.vue?vue&type=script&lang=js&"
export * from "./DialogoUsuariosForm.vue?vue&type=script&lang=js&"
import style0 from "./DialogoUsuariosForm.vue?vue&type=style&index=0&id=2dfabc99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfabc99",
  null
  
)

export default component.exports